class HeaderShrink {
  constructor(slide) {
    this.header = $('.header--big');
    this.headerHeight = false;
    this.buffer = 0;

    this.getHeaderHeight();

    let that = this;

    $(window).scroll(function () {
      let scrollPos = $(document).scrollTop();

      //if (scrollPos > that.headerHeight + that.buffer) {
      if (scrollPos > 20) {
        that.shrinkedHeader();
      } else {

        that.unshrinkHeader();
      }
    });

    $(window).on('resize', function () {
      that.getHeaderHeight();
    });
  }

  getHeaderHeight() {
    let that = this;
    this.headerHeight = this.header.outerHeight();
  }

  getScrollPosition() {
    let that = this;
    let scrollPos = $(document).scrollTop();
  }

  shrinkedHeader() {
    let that = this;
    that.header.addClass('shrinked');
  }

  unshrinkHeader() {
    let that = this;
    that.header.removeClass('shrinked');
  }

}
